<div class="image-background">
  <app-login-dialog (pendingValidationState)="updateValidation($event)" [proResultsParams]="proResultsParams"></app-login-dialog>
  <div [ngClass]="{ hide: pendingValidation }">
    <router-outlet></router-outlet>
  </div>
  <div class="skeleton-loader" *ngIf="notReady">
    <app-loader></app-loader>
  </div>
</div>
